var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_82_1",
    "data-name": "Component 82 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-706 -2305)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 13,
    height: 21,
    rx: 0.5,
    transform: "translate(750 2356) rotate(180)",
    fill: "#1d6bb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    d: "M0,0H12a1,1,0,0,1,1,1V18a4,4,0,0,1-4,4H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z",
    transform: "translate(756 2341) rotate(180)",
    fill: "#1d6bb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 10,
    height: 10,
    rx: 0.5,
    transform: "translate(745 2315) rotate(180)",
    fill: "#ef5a2a"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(-706 -2305)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 12,
    height: 21,
    rx: 0.5,
    transform: "translate(721 2356) rotate(180)",
    fill: "#1d6bb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    d: "M0,0H12a1,1,0,0,1,1,1V18a4,4,0,0,1-4,4H1a1,1,0,0,1-1-1V0A0,0,0,0,1,0,0Z",
    transform: "translate(727 2341) rotate(180)",
    fill: "#1d6bb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M.5,0h9a.5.5,0,0,1,.5.5v9a.5.5,0,0,1-.5.5H.5A.5.5,0,0,1,0,9.5V.5A.5.5,0,0,1,.5,0Z",
    transform: "translate(716 2315) rotate(180)",
    fill: "#ef5a2a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamColored);
export default __webpack_public_path__ + "static/media/team-colored.01f0d822c650af8f49e00444f9fe3103.svg";
export { ForwardRef as ReactComponent };